import { useState } from 'react';
import '../App.css';
import '@reactuiutils/horizontal-timeline/timeline.css';
import {
    Event,
    Subtitle,
    Timeline,
    Title,
} from '@reactuiutils/horizontal-timeline';
import { GiTrophiesShelf } from "react-icons/gi";
import { allSeasons } from '../data/allSeasons';
import CustomTooltip from '../components/CustomTooltip';
import SeasonModal from '../components/SeasonModal';
import Season from '../schemas/Season';
import { allSeasonsData } from '../data/allSeasonsData';
import VeteransDraft from '../schemas/VeteranDraft';
import { allVeteransDrafts } from '../data/allVeteransDrafts';

function TimelinePage() {
    const [show, setShow] = useState(false);
    const [seasonData, setSeasonData] = useState<Season>({
        year: "",
        draftRounds: [],
        finalRanks: [],
        movesLimit: false,
        totalMoves: 0,
        injurySlot: false
    });
    const [seasonVetDraft, setSeasonVetDraft] = useState<VeteransDraft>({
        season: "",
        picks: []
    })

    function handleSeasonClick(e: any) {
        const year = e.target.innerText;
        const chosenSeason = [...allSeasonsData].find((season: Season) =>
            season.year === year);
        const seasonVetDraft = [...allVeteransDrafts].find((draft: VeteransDraft) =>
        draft.season === year);
        if (seasonVetDraft) {
            setSeasonVetDraft(seasonVetDraft);
        }
        if (chosenSeason) {
            setSeasonData(chosenSeason);
            setShow(true);
        }
    }

    return (
        <div id='timeline' className='timeline-wrapper d-flex flex-column justify-content-around'>
            <h3 className='mt-3'>ציר זמנים של תולדות הליגה</h3>
            <p className='mt-2' dir='rtl'>
                רחפו עם העכבר מעל אייקון הפודיום בשביל לראות מי הגיעו אליו בכל עונה.<br/>
              הקלקה על שנת העונה תפתח חלון עם פרטים נוספים עליה
            </p>

            <Timeline
                style={{
                    maxWidth: "80%",
                    margin: "auto"
                }}
            >
                {
                    allSeasons.map((el) => (
                        <CustomTooltip title={el.podiumWinners} key={el.id}>
                            <div>
                                <Event
                                    color="#87a2c7"

                                    icon={GiTrophiesShelf}
                                >
                                    <Title
                                        className='season-title border border-dark-subtle rounded'
                                        onClick={(e) => handleSeasonClick(e)}
                                    >{el.title}</Title>
                                    {
                                        el.subTitle && (
                                            <Subtitle>{el.subTitle}</Subtitle>
                                        )
                                    }
                                </Event>
                            </div>
                        </CustomTooltip>
                    ))
                }
            </Timeline>
            <SeasonModal
                show={show}
                setShow={setShow}
                fullscreen={true}
                clickedSeason={seasonData}
                seasonVetDraft={seasonVetDraft}
            />
        </div>
    )
}

export default TimelinePage;